import { _ as __read } from '../../../_tslib-7a01aab4.js';
import React, { useState, useRef } from 'react';

var isMouseDown = false;
var startX = 0;
var scrollLeft = 0;
var HorizontalScroll = function (_a) {
    var _b = _a.speed, speed = _b === void 0 ? 1 : _b, children = _a.children, _c = _a.additionalRef, additionalRef = _c === void 0 ? null : _c, setIsScrollingFalse = _a.setIsScrollingFalse, additionalClassNames = _a.additionalClassNames, onMouseUpAdditionalFunction = _a.onMouseUpAdditionalFunction, onMouseMoveAdditionalFunction = _a.onMouseMoveAdditionalFunction, onMouseDownAdditionalFunction = _a.onMouseDownAdditionalFunction, onMouseLeaveAdditionalFunction = _a.onMouseLeaveAdditionalFunction;
    var _d = __read(useState(), 2), clientX = _d[0], setClientX = _d[1];
    var slider = additionalRef || useRef();
    var handleMouseDown = function (event) {
        isMouseDown = true;
        if (onMouseDownAdditionalFunction) {
            onMouseDownAdditionalFunction();
        }
        startX = event.pageX - slider.current.offsetLeft;
        scrollLeft = slider.current.scrollLeft;
        setClientX(event.clientX);
    };
    var handleMouseLeave = function () {
        isMouseDown = false;
        setIsScrollingFalse();
        if (onMouseLeaveAdditionalFunction) {
            onMouseLeaveAdditionalFunction();
        }
    };
    var handleMouseUp = function (event) {
        isMouseDown = false;
        setIsScrollingFalse();
        if (event.clientX === clientX && onMouseUpAdditionalFunction) {
            onMouseUpAdditionalFunction();
        }
    };
    var handleMouseMove = function (event) {
        if (!isMouseDown) {
            setIsScrollingFalse();
            return;
        }
        if (onMouseMoveAdditionalFunction) {
            onMouseMoveAdditionalFunction();
        }
        event.preventDefault();
        var x = event.pageX - slider.current.offsetLeft;
        var walk = (x - startX) * speed;
        slider.current.scrollLeft = scrollLeft - walk;
    };
    return (React.createElement("div", { ref: slider, onMouseUp: handleMouseUp, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseLeave: handleMouseLeave, className: "horizontal-scroll-wr ".concat(additionalClassNames) }, children));
};

export { HorizontalScroll };
